import { STORAGE_SCHEMA_VERSION } from '@texas42/app-model';
import {
  AI_BID_POLICY_VERSION,
  AI_BID_RECEIPT_VERSION,
  AI_DECLARATION_POLICY_VERSION,
  AI_DECLARATION_RECEIPT_VERSION,
  AI_PLAY_POLICY_VERSION,
  AI_PLAY_RECEIPT_VERSION,
} from '@texas42/game-runtime';
import { APP_VERSION, ENGINE_VERSION } from '../../platform/persistence/constants.js';
import type { ActiveExpertSession } from './types.js';

export function expertCampaignVersionMismatch(session: ActiveExpertSession): boolean {
  return session.expectedAppVersion !== APP_VERSION ||
    session.expectedEngineVersion !== ENGINE_VERSION ||
    session.expectedMatchSchemaVersion !== STORAGE_SCHEMA_VERSION ||
    session.expectedPlayPolicyVersion !== AI_PLAY_POLICY_VERSION ||
    session.expectedBidPolicyVersion !== AI_BID_POLICY_VERSION ||
    session.expectedDeclarationPolicyVersion !== AI_DECLARATION_POLICY_VERSION ||
    session.expectedPlayReceiptVersion !== AI_PLAY_RECEIPT_VERSION ||
    session.expectedBidReceiptVersion !== AI_BID_RECEIPT_VERSION ||
    session.expectedDeclarationReceiptVersion !== AI_DECLARATION_RECEIPT_VERSION;
}
